/* app/js/src/components/live/createEditLiveFeed/live-feed-preview.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: relative;
  display: inline-block;
}
video {
  width: 100%;
  background-color: black;
}
.availability-zones {
  display: flex;
  height: 53px;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  bottom: 0;
}
.availability-zones .btn {
  height: 30px;
  color: white;
  background-color: #7d8fa1;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  cursor: pointer;
}
.availability-zones .btn.selected {
  background-color: #93a9bf;
}
/*# sourceMappingURL=live-feed-preview.component.css.map */
